"use client";
import React from "react";

import Example from "../Example.jsx";
import Case from "../Case.jsx";
import { NumSlider } from "src/components/ui/NumSlider";
import Text from "../../../src/components/ui/Text";

const Var = ({ children }) => (
  <span className="font-bold">{children || ""}</span>
);

const DoublingContinuesExample = () => {
  return (
    <Example>
      <Case rate={7}>
        {({ rate, doublingPeriod, multiple, onRateChange }) => (
          <Text>
            <NumSlider
              num={rate}
              percent
              step={1}
              min={1}
              max={20}
              onChange={onRateChange}
            />{" "}
            interest rate has doubling period of approx{" "}
            <Var>{Math.round(doublingPeriod)}</Var> years. By year{" "}
            <Var>{Math.round(doublingPeriod * 3)}</Var> (3 doubling years), your
            investment would grow to 8 times the initial investment. And if you
            wait another <Var>{Math.round(doublingPeriod)}</Var> years, it will
            grow to 16 times.
          </Text>
        )}
      </Case>
    </Example>
  );
};

export default DoublingContinuesExample;
